export const smallScreens = matchMedia('(max-height: 450px)');
export const smallWidthScreens = matchMedia('(max-width: 1199px)');